<template>
  <div class="container-fluid content">
    <br />
    <div style="text-align: left">
      <el-button @click="addAppleDeveloperAccount" type="success">添加账号</el-button>
    </div>
    <p></p>
    <el-table :data="appleDeveloperAccounts">
      <el-table-column prop="appleId" label="Apple Id">
      </el-table-column>
      <el-table-column prop="issuerId" label="issuer Id">
      </el-table-column>
      <el-table-column prop="certName" label="证书名" width="400">
      </el-table-column>
      <el-table-column label="是否可用" width="100">
        <template slot-scope="scope">
          <el-select v-model="appleDeveloperAccounts[scope.$index].useable"
            @change="updateUseAble(appleDeveloperAccounts[scope.$index].id,$event)">
            <el-option label="正常" :value=true></el-option>
            <el-option label="禁用" :value=false></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="useNum" label="使用数量" sortable></el-table-column>
      <el-table-column prop="createTime" label="创建时间" :formatter="vueFormatDateTime" sortable></el-table-column>
    </el-table>
    <el-dialog title="开发者账号新增" :visible.sync="dialogVisible" @close="dialogClose" :close-on-click-modal="false"
      :width="dialogWidth">
      <div style="text-align: left;">
        <el-alert title="注意事项" type="warning" description="1.申请苹果个人开发者账号时，请不要使用同一张信用卡用于支付多个账号订单，否则容易导致封号。" effect="dark"
          :closable="false">
        </el-alert>
        <el-alert type="warning" description="2.添加成功后，系统会自动创建证书、设备和描述文件，请勿删除这些文件，否则会导致用户安装的软件闪退或无法安装！" :center="false"
          effect="dark" :closable="false">
        </el-alert>
        <br />
      </div>
      <div v-loading="loading">
        <el-form ref="form" :model="formData" :rules="rules" label-width="6em">
          <el-form-item label="Apple Id" prop="appleId">
            <el-input v-model="formData.appleId"></el-input>
          </el-form-item>
          <el-form-item label="Issuer ID" prop="issuerId">
            <el-input v-model="formData.issuerId"></el-input>
          </el-form-item>
          <el-form-item label="密钥 ID" prop="privateKeyId">
            <el-input v-model="formData.privateKeyId"></el-input>
          </el-form-item>
          <el-form-item label="API 密钥" prop="apiPrivateKey">
            <el-input type="textarea" v-model="formData.apiPrivateKey" rows="5"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="onSubmit" type="primary">提交</el-button>
          <el-button @click="resetForm()" type="warning">重置</el-button>
        </span>
      </div>
    </el-dialog>
  </div>

</template>

<script>
export default {
  mounted() {
    this.getAppleDeveloperAccount();
    if (this.getScreenWidth() < 768) {
      this.dialogWidth = "90%";
    }
  },

  data() {
    return {
      appleDeveloperAccounts: [],
      dialogVisible: false,
      dialogWidth: "35%",
      loading: false,
      formData: {
        appleId: "",
        issuerId: null,
        privateKeyId: null,
        apiPrivateKey: null
      },
      rules: {
        appleId: [
          { required: true, message: "请输入appleId", trigger: "blur" }
        ],
        issuerId: [
          { required: true, message: "请输入issuerId", trigger: "blur" }
        ],
        privateKeyId: [
          { required: true, message: "请输入privateKeyId", trigger: "blur" }
        ],
        apiPrivateKey: [
          { required: true, message: "请输入apiPrivateKey", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    resetForm() {
      this.$refs["form"].resetFields()
    },
    addAppleDeveloperAccount: function() {
      this.dialogVisible = true;
    },
    getAppleDeveloperAccount: function() {
      this.$http
        .post(this._Global.HTTP_SERVER + "/auth/appleDeveloper/account/list", {
          authToken: this.getToken()
        })
        .then(response => {
          this.respDataHandle(response.body, data => {
            this.appleDeveloperAccounts = data;
          });
        });
    },
    dialogClose: function() {
      this.loading = false;
      this.appleId = "";
      this.password = "";
      this.getAppleDeveloperAccount();
    },
    onSubmit: function() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.formData.authToken=this.getToken()
          this.loading = true;
          this.$http
            .post(
              this._Global.HTTP_SERVER + "/auth/appleDeveloper/account/add",
              this.formData
            )
            .then(response => {
              this.respDataHandle(
                response.body,
                data => {
                  this.loading = false;
                  if (data) {
                    this.$message({
                      message: "个人开发者账号添加成功",
                      type: "success"
                    });
                  } else {
                    this.$message.error("个人开发者账号添加失败");
                  }
                },
                () => {
                  this.loading = false;
                }
              );
            });
        }
      });
    },
    updateUseAble: function(id, event) {
      var params = {};
      params.id = id;
      params.useable = event;
      params.authToken = this.getToken();
      this.$http
        .post(
          this._Global.HTTP_SERVER + "/auth/apple/developer/account/update",
          params
        )
        .then(response => {
          this.respDataHandle(response.body, function(data) {
            window.layer.msg("修改成功");
          });
        });
    }
  },
  components: {}
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/AppleDeveloperAccount.vue